const STORAGE_KEY = "DEBUG_PAGE_BFF";
const QUERY_KEY = "debug_bff";

function hasDebugQuery(search: string) {
	try {
		return new URLSearchParams(search).get(QUERY_KEY) === "1";
	} catch {
		return false;
	}
}

export function isPageBffDebugEnabled() {
	if (process.env.DEBUG_PAGE_BFF === "1") {
		return true;
	}

	if (import.meta.client && typeof window !== "undefined") {
		try {
			if (window.localStorage?.getItem(STORAGE_KEY) === "1") {
				return true;
			}
		} catch {
			// ignore storage access errors
		}

		return hasDebugQuery(window.location.search);
	}

	if (import.meta.server) {
		try {
			return hasDebugQuery(useRequestURL().search);
		} catch {
			return false;
		}
	}

	return false;
}

export function logPageBff(label: string, payload?: unknown) {
	if (!isPageBffDebugEnabled()) return;
	console.log(`[page-bff] ${label}`, payload);
}
